<!--
  Usage:

  <Collapser>
    <ul>
      <li>Item 1</li>
      <li>Item 2</li>
      <li>Item 3</li>
      <li>Item 4</li> // Content begins to fade out around here.
      <li>Item 5</li>
      ...
    </ul>
  </Collapser>

-->

<template>
  <div class="Collapser" v-if="active">
    <div  class="Collapser-content"
         :style="isCollapsed ? `max-height: ${height}px; overflow: hidden` : ''">

      <Overlay  :opacity="1"
                :colour="'linear-gradient(to bottom,'     +
                            'rgba(var(--black), .1) 10%,'  +
                            'rgba(var(--black), .8) 100%' +
                          ')'"
                v-if="isCollapsed"></Overlay>

      <div class="Collapser-body">
        <slot></slot>
      </div>
    </div>

    <div class="Collapser-toggle Button" @click="toggle">
      <i class="fas fa-angle-down" v-if=" isCollapsed"></i>
      <i class="fas fa-angle-up"   v-if="!isCollapsed"></i>
    </div>
  </div>

  <div v-else>
    <slot></slot>
  </div>
</template>

<script>
  import Overlay from '@/legacy/components/widgets/Overlay';

  export default {
    props: {
      height: {
        type: Number,
        default: 200
      },

      active: {
        type: Boolean,
        default: true
      }
    },

    components: {
      Overlay
    },

    data: function () {
      return {
        isCollapsed: true
      };
    },

    methods: {
      toggle: function () {
        this.isCollapsed = !this.isCollapsed;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .Collapser {
    &-content {
      position: relative;
      z-index: fetch(z-index behind);
    }

    &-body {
    }

    &-toggle {
      padding: 0;
      margin: 0;

      border-color: rgba(var(--grey), .8);
    }
  }
</style>